import { GladlyUserProps } from './types';

export const gladlyInit = async (appId: string): Promise<boolean> => {
  if (typeof window !== 'undefined' && window.Gladly) {
    const { Gladly } = window;

    try {
      await Gladly.init({ appId, autoShowButton: false });
      return true;
    } catch (_error) {
      return false;
    }
  }
  return false;
};

export const gladlyShow = () => {
  if (typeof window !== 'undefined' && window?.Gladly?.show) {
    const { Gladly } = window;

    Gladly.show();
  }
};

export const setGladlyUser = (user: GladlyUserProps) => {
  if (typeof window !== 'undefined' && window?.Gladly?.setUser) {
    const { Gladly } = window;

    Gladly.setUser(user);
  }
};

export const clearGladlyUser = () => {
  if (typeof window !== 'undefined' && window?.Gladly?.clearUser) {
    const { Gladly } = window;

    Gladly.clearUser();
  }
};

export const setGladlyNavigate = () => {
  if (typeof window !== 'undefined' && window?.Gladly?.navigate) {
    const { Gladly } = window;

    Gladly.navigate();
  }
};
